import NetworkIcon from '@src/icons/eco-event/network.svg';
import EventsIcon from '@src/icons/eco-event/event.svg';
import NetworkWithBgIcon from '@src/icons/eco-event/network-with-bg.svg';
import EventWithBgIcon from '@src/icons/eco-event/event-with-bg.svg';
import EventsDashIcon from '@src/icons/eco-event/events-dash.svg';
import ServicePerformanceDashIcon from '@src/icons/eco-event/service-performance-dash.svg';
import AnalysisIcon from '@icons/analysis.svg';

export const dimensionByCategory = {
  events: ['event_name', 'event_category'],
  network: [
    'network_request_url_host',
    'network_request_url_port',
    'network_request_url_path',
    'network_request_http_method',
    'network_request_response_code',
    'network_request_url_scheme',
    'network_request_url_query',
  ],
};

export const dimensionToCategory = Object.entries(dimensionByCategory).reduce<object>(
  (res, [k, v]) => {
    return {
      ...res,
      ...v.reduce<object>((sum, it) => {
        return { ...sum, [it]: k };
      }, {}),
    };
  },
  {},
);

export {
  NetworkIcon,
  EventsIcon,
  NetworkWithBgIcon,
  EventWithBgIcon,
  EventsDashIcon,
  ServicePerformanceDashIcon,
  AnalysisIcon,
};
